import React from "react";
import { Container, Row, Col } from "reactstrap";
import courseImg1 from "../../assests/images/web-design.png";
import courseImg2 from "../../assests/images/graphics-design.png";
import courseImg3 from "../../assests/images/ui-ux.png";
import "./courses.css";
import CourseCard from "./CourseCard";


import gifImage01 from "../../assests/images/.gif/header.gif";
import gifImage02 from "../../assests/images/.gif/python.gif";
import gifImage03 from "../../assests/images/.gif/giphy-5.gif";
import gifImage04 from "../../assests/images/.gif/cfea2f3d4d8a7d15947b1397fee3e720.gif";

const coursesData = [
  {
    id: "01",
    title: "Eсептің қойылымы (қандай физикалық шамалар берілген және нені табу керек)",
    lesson: ``,
    students: ``,
    rating: ``,
    imgUrl: gifImage04,
  },

  {
    id: "02",
    title: "Mатематикалық модельді анықтау (физикалық заңдар, шарттар)",
    lesson: ``,
    students: ``,
    rating: ``,
    imgUrl: gifImage03,
  },

  {
    id: "03",
    title: "Mатематикалық модельді шешу әдісін таңдау және қолдану",
    lesson: ``,
    students: ``,
    rating: ``,
    imgUrl: gifImage02,
  },
];

const Courses = () => {
  return (
    <section>
      <Container>
        <Row>
          <Col lg="12" className="mb-5">
            <div className="course__top d-flex justify-content-between align-items-center">
              <div className="course__top__left w-100">
                <h2>Физикалық процестер</h2>
                <p>
                  Физикалық процестерді компьютерлік модельдеу 20 ғасырдың екінші жартысынан бастап дамып келеді. Есептеуіш техниканың дамуымен қатар машиналық есептеулер мен алгоритмдер туралы ғылым (computer science) қатарласып дамуда.
                  Есептеу техникасының қолдану аясы біртіндеп кеңейе отырып, қазіргі уақытта сандық электроника адам өмірінің барлық салаларындағы, тәжірибеге еніп кетті, сондықтан  есептеу техникасын қолдану дағдылары мен дағдыларын қалыптастыру заманауи маманның өзекті мәселесі болып отыр.
                </p>
              </div>

              <div className="w-50 text-end">
                {/* <button className="btn">Компьютерлік Модельдеу</button> */}
              </div>
            </div>
          </Col>
          {coursesData.map((item) => (
            <Col lg="4" md="6" sm="6">
              <CourseCard key={item.id} item={item} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Courses;
